import { useSnackbar } from 'notistack';

export const useSnackMessages = () => {
    const { enqueueSnackbar } = useSnackbar();

    return {
        msgBasicError: (msg, persist, autoHideDuration) =>
            enqueueSnackbar(msg, { variant: 'basicErrorAlert', persist: persist, autoHideDuration: autoHideDuration }),
        msgBasicSuccess: (msg, persist, autoHideDuration) =>
            enqueueSnackbar(msg, { variant: 'basicSuccessAlert', persist: persist, autoHideDuration: autoHideDuration }),
        msgBasicWarning: (msg, persist, autoHideDuration) =>
            enqueueSnackbar(msg, { variant: 'basicWarningAlert', persist: persist, autoHideDuration: autoHideDuration }),
        msgBasicInfo: (msg, persist, autoHideDuration) =>
            enqueueSnackbar(msg, { variant: 'basicInfoAlert', persist: persist, autoHideDuration: autoHideDuration })
    };
};
